{
  "familyId": "GET-BREUK-GEL-PLUS",
  "questions": [
    {
      "id": "GET-BREUK-GEL-PLUS-001",
      "familyId": "GET-BREUK-GEL-PLUS",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_optellen_gel",
      "questionType": "multiple_choice",
      "question": "Een leerling schrijft op het bord: $\\frac{1}{4}$ + $\\frac{2}{4}$ = $\\frac{3}{8}$. De juf zegt dat het fout is. Wat is het goede antwoord?",
      "context": null,
      "options": ["$\\frac{3}{4}$", "$\\frac{3}{8}$", "$\\frac{2}{4}$", "$\\frac{1}{2}$"],
      "correctAnswer": 0,
      "conceptId": "add_like_fractions_quarters",
      "variantIndex": 1,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.78,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 1, "denominator": 4, "label": "1/4"},
              {"numerator": 2, "denominator": 4, "label": "2/4"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 4,
            "label": "1/4 + 2/4 = 3/4",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "De leerling heeft de noemers ook opgeteld (4 + 4 = 8), maar dat mag niet. Bij gelijknamige breuken tel je alleen de tellers op: 1 + 2 = 3. De noemer blijft 4. Dus $\\frac{1}{4}$ + $\\frac{2}{4}$ = $\\frac{3}{4}$. Denk aan een pizza in 4 stukken: 1 stuk + 2 stukken = 3 stukken van dezelfde grootte.",
        "solutionSteps": [
          "Herken de fout: de leerling telde de noemers op (4 + 4 = 8)",
          "Regel: bij gelijknamige breuken blijft de noemer hetzelfde",
          "Tel alleen de tellers op: 1 + 2 = 3",
          "Antwoord: $\\frac{3}{4}$"
        ],
        "distractorExplanations": {
          "0": "Goed! De leerling had de noemers opgeteld, maar dat mag niet. Tel alleen de tellers op: 1 + 2 = 3, noemer blijft 4.",
          "1": "Je dacht waarschijnlijk dat de leerling gelijk had. Maar $\\frac{3}{8}$ is fout — je mag de noemers niet optellen. Bij gelijknamige breuken blijft de noemer hetzelfde: $\\frac{1}{4}$ + $\\frac{2}{4}$ = $\\frac{3}{4}$.",
          "2": "Je dacht waarschijnlijk dat het antwoord $\\frac{2}{4}$ is. Maar je moet beide breuken optellen: 1 + 2 = 3 (niet alleen de tweede breuk nemen). Antwoord: $\\frac{3}{4}$.",
          "3": "Je dacht waarschijnlijk dat $\\frac{1}{2}$ het antwoord is. Maar $\\frac{1}{2}$ = $\\frac{2}{4}$ — dat is alleen de tweede breuk. Tel beide tellers op: 1 + 2 = 3, dus $\\frac{3}{4}$."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-PLUS-002",
      "familyId": "GET-BREUK-GEL-PLUS",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_optellen_gel",
      "questionType": "multiple_choice",
      "question": "Een bakker snijdt een taart in 5 gelijke stukken. Hij verkoopt $\\frac{2}{5}$ aan de eerste klant en $\\frac{1}{5}$ aan de tweede klant. Welk deel van de taart is er nog over?",
      "context": null,
      "options": ["$\\frac{2}{5}$", "$\\frac{3}{5}$", "$\\frac{3}{10}$", "$\\frac{4}{5}$"],
      "correctAnswer": 0,
      "conceptId": "add_like_fractions_fifths",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 2, "denominator": 5, "label": "Klant 1: 2/5"},
              {"numerator": 1, "denominator": 5, "label": "Klant 2: 1/5"}
            ],
            "operator": "+",
            "visualType": "circle"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 5,
            "label": "Over: 5/5 - 3/5 = 2/5",
            "visualType": "circle"
          }
        }
      ],
      "feedback": {
        "explanationText": "Eerst: hoeveel is er verkocht? $\\frac{2}{5}$ + $\\frac{1}{5}$ = $\\frac{3}{5}$. De hele taart = $\\frac{5}{5}$. Over: $\\frac{5}{5}$ − $\\frac{3}{5}$ = $\\frac{2}{5}$. Er zijn nog 2 van de 5 stukken over.",
        "solutionSteps": [
          "Bereken hoeveel er verkocht is: $\\frac{2}{5}$ + $\\frac{1}{5}$ = $\\frac{3}{5}$",
          "De hele taart = $\\frac{5}{5}$ (5 van de 5 stukken)",
          "Trek af: $\\frac{5}{5}$ − $\\frac{3}{5}$ = $\\frac{2}{5}$",
          "Er is nog $\\frac{2}{5}$ van de taart over"
        ],
        "distractorExplanations": {
          "0": "Goed! Verkocht: $\\frac{2}{5}$ + $\\frac{1}{5}$ = $\\frac{3}{5}$. Over: $\\frac{5}{5}$ − $\\frac{3}{5}$ = $\\frac{2}{5}$.",
          "1": "Je dacht waarschijnlijk dat $\\frac{3}{5}$ het antwoord is. Maar $\\frac{3}{5}$ is hoeveel er verkocht is, niet hoeveel er over is. Trek af van het geheel: $\\frac{5}{5}$ − $\\frac{3}{5}$ = $\\frac{2}{5}$.",
          "2": "Je dacht waarschijnlijk dat je de noemers ook moet optellen (5 + 5 = 10). Maar bij gelijknamige breuken blijft de noemer hetzelfde. Verkocht: $\\frac{3}{5}$. Over: $\\frac{2}{5}$.",
          "3": "Je dacht waarschijnlijk dat er $\\frac{4}{5}$ over is. Maar er zijn 3 stukken verkocht (2 + 1 = 3), niet 1 stuk. Over: 5 − 3 = 2 stukken = $\\frac{2}{5}$."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-PLUS-003",
      "familyId": "GET-BREUK-GEL-PLUS",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_optellen_gel",
      "questionType": "multiple_choice",
      "question": "De meester schrijft twee sommen op het bord: A) $\\frac{3}{8}$ + $\\frac{2}{8}$ = $\\frac{5}{8}$ en B) $\\frac{3}{8}$ + $\\frac{2}{8}$ = $\\frac{5}{16}$. Welke som is goed?",
      "context": null,
      "options": ["Alleen A is goed", "Alleen B is goed", "Allebei goed", "Allebei fout"],
      "correctAnswer": 0,
      "conceptId": "add_like_fractions_eighths",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 3, "denominator": 8, "label": "3/8"},
              {"numerator": 2, "denominator": 8, "label": "2/8"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 8,
            "label": "3/8 + 2/8 = 5/8",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Som A is goed: 3 + 2 = 5, noemer blijft 8 → $\\frac{5}{8}$. Som B is fout: de leerling heeft de noemers ook opgeteld (8 + 8 = 16). Bij gelijknamige breuken blijft de noemer altijd hetzelfde.",
        "solutionSteps": [
          "Controleer som A: tellers optellen 3 + 2 = 5, noemer blijft 8 → $\\frac{5}{8}$ ✓",
          "Controleer som B: noemer 16 = 8 + 8 → de noemers zijn opgeteld ✗",
          "Regel: bij gelijknamige breuken tel je alleen de tellers op",
          "Alleen som A is goed"
        ],
        "distractorExplanations": {
          "0": "Goed! Som A ($\\frac{5}{8}$) is correct. Bij gelijknamige breuken tel je alleen de tellers op, de noemer blijft hetzelfde.",
          "1": "Je dacht waarschijnlijk dat je de noemers ook moet optellen. Maar bij gelijknamige breuken blijft de noemer hetzelfde: $\\frac{3}{8}$ + $\\frac{2}{8}$ = $\\frac{5}{8}$, niet $\\frac{5}{16}$.",
          "2": "Je dacht waarschijnlijk dat beide antwoorden kloppen. Maar $\\frac{5}{8}$ ≠ $\\frac{5}{16}$ — het zijn verschillende getallen. Alleen $\\frac{5}{8}$ is het juiste antwoord.",
          "3": "Je dacht waarschijnlijk dat beide fout zijn. Maar som A is wél goed: 3 + 2 = 5, noemer blijft 8 → $\\frac{5}{8}$. Controleer: 3 achtsten + 2 achtsten = 5 achtsten ✓."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-PLUS-004",
      "familyId": "GET-BREUK-GEL-PLUS",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_optellen_gel",
      "questionType": "multiple_choice",
      "question": "Een leraar vraagt: 'Ik heb $\\frac{1}{6}$ van een chocoladereep gegeten. Mijn collega eet $\\frac{4}{6}$. Kunnen we samen meer dan de helft hebben gegeten?' Wat is het antwoord?",
      "context": null,
      "options": ["Ja, want $\\frac{5}{6}$ > $\\frac{1}{2}$", "Nee, want $\\frac{5}{12}$ < $\\frac{1}{2}$", "Ja, want $\\frac{4}{6}$ > $\\frac{1}{2}$", "Nee, want $\\frac{5}{6}$ < $\\frac{1}{2}$"],
      "correctAnswer": 0,
      "conceptId": "add_like_fractions_sixths",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 1, "denominator": 6, "label": "Leraar: 1/6"},
              {"numerator": 4, "denominator": 6, "label": "Collega: 4/6"}
            ],
            "operator": "+",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 6,
            "label": "1/6 + 4/6 = 5/6 (meer dan de helft)",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Eerst optellen: $\\frac{1}{6}$ + $\\frac{4}{6}$ = $\\frac{5}{6}$. Dan vergelijken met de helft: $\\frac{1}{2}$ = $\\frac{3}{6}$. Is $\\frac{5}{6}$ > $\\frac{3}{6}$? Ja, want 5 > 3. Ze hebben samen meer dan de helft gegeten.",
        "solutionSteps": [
          "Tel op: $\\frac{1}{6}$ + $\\frac{4}{6}$ = $\\frac{5}{6}$",
          "Schrijf de helft als zesde: $\\frac{1}{2}$ = $\\frac{3}{6}$",
          "Vergelijk: $\\frac{5}{6}$ > $\\frac{3}{6}$ (want 5 > 3)",
          "Ja, ze hebben meer dan de helft gegeten"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{6}$ + $\\frac{4}{6}$ = $\\frac{5}{6}$. De helft = $\\frac{3}{6}$. Omdat 5 > 3, is $\\frac{5}{6}$ meer dan de helft.",
          "1": "Je dacht waarschijnlijk dat je de noemers ook moet optellen (6 + 6 = 12). Maar bij gelijknamige breuken blijft de noemer hetzelfde: $\\frac{1}{6}$ + $\\frac{4}{6}$ = $\\frac{5}{6}$, niet $\\frac{5}{12}$.",
          "2": "Je dacht waarschijnlijk dat je alleen naar de collega hoeft te kijken. Maar de vraag is over samen — je moet eerst optellen: $\\frac{1}{6}$ + $\\frac{4}{6}$ = $\\frac{5}{6}$.",
          "3": "Je dacht waarschijnlijk dat $\\frac{5}{6}$ kleiner is dan $\\frac{1}{2}$. Maar $\\frac{1}{2}$ = $\\frac{3}{6}$, en 5 > 3. Dus $\\frac{5}{6}$ is méér dan de helft."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-PLUS-005",
      "familyId": "GET-BREUK-GEL-PLUS",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_optellen_gel",
      "questionType": "multiple_choice",
      "question": "Lisa eet $\\frac{2}{8}$ van een pizza en haar broer eet $\\frac{3}{8}$. Lisa zegt: 'Samen hebben we $\\frac{5}{16}$ gegeten.' Wat klopt er niet aan Lisa's antwoord?",
      "context": null,
      "options": [
        "Ze heeft de noemers opgeteld — het antwoord is $\\frac{5}{8}$",
        "Ze heeft de tellers fout opgeteld — het moet $\\frac{6}{8}$ zijn",
        "Ze had moeten aftrekken — het antwoord is $\\frac{1}{8}$",
        "Haar antwoord is wel goed"
      ],
      "correctAnswer": 0,
      "conceptId": "add_like_fractions_context",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 2, "denominator": 8, "label": "Lisa: 2/8"},
              {"numerator": 3, "denominator": 8, "label": "Broer: 3/8"}
            ],
            "operator": "+",
            "visualType": "circle"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 5,
            "denominator": 8,
            "label": "2/8 + 3/8 = 5/8 van de pizza",
            "visualType": "circle"
          }
        }
      ],
      "feedback": {
        "explanationText": "Lisa heeft de noemers ook opgeteld: 8 + 8 = 16. Maar bij gelijknamige breuken blijft de noemer hetzelfde. De pizza is in 8 stukken verdeeld, niet 16. Het goede antwoord: $\\frac{2}{8}$ + $\\frac{3}{8}$ = $\\frac{5}{8}$. Tel alleen de tellers op: 2 + 3 = 5.",
        "solutionSteps": [
          "Herken Lisa's fout: ze telde de noemers op (8 + 8 = 16)",
          "Regel: bij gelijknamige breuken blijft de noemer hetzelfde",
          "Goed: tel alleen de tellers op: 2 + 3 = 5",
          "Antwoord: $\\frac{5}{8}$ van de pizza"
        ],
        "distractorExplanations": {
          "0": "Goed! Lisa telde de noemers op (8 + 8 = 16). De noemer moet 8 blijven. Het juiste antwoord is $\\frac{5}{8}$.",
          "1": "Je dacht waarschijnlijk dat Lisa de tellers fout optelde. Maar 2 + 3 = 5 klopt wél. Haar fout zit in de noemer: ze schreef 16 in plaats van 8. $\\frac{6}{8}$ zou kloppen als het 3 + 3 was.",
          "2": "Je dacht waarschijnlijk dat je moet aftrekken. Maar de vraag is hoeveel ze samen eten — dat is optellen. $\\frac{2}{8}$ + $\\frac{3}{8}$ = $\\frac{5}{8}$.",
          "3": "Je dacht waarschijnlijk dat Lisa gelijk heeft. Maar $\\frac{5}{16}$ is fout — de pizza is in 8 stukken, niet 16. Bij gelijknamige breuken tel je de noemers niet op."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-PLUS-008",
      "familyId": "GET-BREUK-GEL-PLUS",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_optellen_gel",
      "questionType": "fill_in",
      "question": "Reken uit: $\\frac{3}{10}$ + $\\frac{4}{10}$ = ? Typ je antwoord als breuk (bijv. 5/6).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["7/10", "7 / 10"],
        "caseSensitive": false,
        "placeholder": ".../..."
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 3, "denominator": 10, "label": "3/10"},
              {"numerator": 4, "denominator": 10, "label": "4/10"}
            ],
            "operation": "+",
            "label": "Gelijknamige breuken optellen"
          }
        }
      ],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Gelijknamige breuken optellen", "content": "Bij gelijknamige breuken (dezelfde noemer) tel je alleen de tellers op. De noemer blijft hetzelfde. 3/10 + 4/10 = 7/10.", "icon": "lightbulb" } }
      ],
      "conceptId": "add_like_fractions_tenths_fill",
      "variantIndex": 8,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Bij gelijknamige breuken tel je alleen de tellers op: 3 + 4 = 7. De noemer blijft 10. Antwoord: $\\frac{7}{10}$.",
        "solutionSteps": [
          "Dezelfde noemer (10) → tel alleen de tellers op",
          "3 + 4 = 7",
          "Noemer blijft 10",
          "Antwoord: 7/10"
        ]
      }
    }
  ]
}